import type { ShipToBranch } from '../../lib/distributorsApi';

export const SRS_TBD_DATE = '2029-12-31';
export const SRS_CHECKOUT_DISCLAIMER = 'Additional charges may apply beyond the quoted line item prices. Sales tax will be calculated at checkout based on delivery location. Pricing subject to change between quote and order submission. Unit conversion may affect totals (e.g., SQ to BD conversions).';
export const SRS_CALL_BRANCH = 'Please call branch for product pricing.';
export const SRS_SERVICE_LABELS: Record<string, string> = { GROUND_DROP: 'Ground Drop', ROOF_LOAD: 'Roof Load', ROOF_EDGE: 'Roof Edge', WILLCALL: 'Pick Up' };

export function srsPickupTimes(branch: ShipToBranch | null | undefined, date: string): string[] {
  if (!branch?.supports_pickup || !date || date === SRS_TBD_DATE) return [];
  const day = new Date(`${date}T12:00:00`).getDay();
  return day === 0 ? [] : day === 6 ? branch.pickup_times_saturday || [] : branch.pickup_times_weekday || [];
}
